import React from 'react';
import { motion } from 'framer-motion';
const images = ['https://images.unsplash.com/photo-1515377905703-c4788e51af15?auto=format&fit=crop&q=80&w=400', 'https://images.unsplash.com/photo-1552693673-1bf958298935?auto=format&fit=crop&q=80&w=400', 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&q=80&w=400', 'https://images.unsplash.com/photo-1509967419530-da38b4704bc6?auto=format&fit=crop&q=80&w=400', 'https://images.unsplash.com/photo-1544507888-56d73eb6046e?auto=format&fit=crop&q=80&w=400', 'https://images.unsplash.com/photo-1500522144261-ea64433eb38d?auto=format&fit=crop&q=80&w=400'];
export function CollageBand() {
  return <section className="relative w-full h-[400px] sm:h-[500px] bg-slate-900 overflow-hidden flex items-center justify-center mt-12" data-id="element-1">
      {/* Background Collage */}
      <div className="absolute inset-0 opacity-40" data-id="element-2">
        <div className="relative w-full h-full flex flex-wrap justify-center items-center gap-4 p-8" data-id="element-3">
          {images.map((src, i) => <motion.div key={i} initial={{
          opacity: 0,
          scale: 0.8
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1,
          duration: 0.5
        }} className="relative w-32 h-32 sm:w-48 sm:h-48 rounded-xl overflow-hidden shadow-2xl" style={{
          transform: `rotate(${i % 2 === 0 ? 5 : -5}deg) translateY(${i % 3 === 0 ? 20 : -20}px)`
        }} data-id="element-4">
              <img src={src} alt="Anwenderin" className="w-full h-full object-cover grayscale hover:grayscale-0 transition-all duration-500" data-id="element-5" />
              {/* Overlay simulating the device glow */}
              <div className="absolute inset-0 bg-rose-500/20 mix-blend-overlay" data-id="element-6"></div>
            </motion.div>)}
        </div>
      </div>

      {/* Center Wordmark */}
      <div className="relative z-10 text-center" data-id="element-7">
        <h2 className="font-serif text-6xl sm:text-8xl md:text-9xl font-bold text-white tracking-[0.2em] drop-shadow-2xl" data-id="element-8">
          RYLTE
        </h2>
      </div>
    </section>;
}